<template>
    <div id="setting">
        <div class="header"></div>
        <div class="info">
            <div class="name-box">
                <div class="info-name">
                    <span class="photo"></span>
                    <div class="name">{{info.nickname}}</div>
                    <div class="address">{{info.districtName}}</div>
                </div>
            </div>
            <van-cell-group>
                <van-cell @click="dialogShow=true" is-link>
                    <div class="cell-title" slot="title">昵称：<span class="cell-name">{{info.nickname}}</span></div>
                </van-cell>
                <van-cell>
                    <div class="cell-title" slot="title">手机：<span class="cell-name">{{info.mobile}}</span></div>
                </van-cell>
                <van-cell>
                    <div class="cell-title" slot="title">会员号：<span class="cell-name">{{info.memberNumber}}</span></div>
                </van-cell>
            </van-cell-group>
        </div>
        <van-dialog title="修改昵称" show-cancel-button v-model="dialogShow" :before-close="beforeClose">
            <van-field label="昵称" v-model="nickName" placeholder="请输入新的昵称"/>
        </van-dialog>
    </div>
</template>

<script>
import { Toast } from "vant";
export default {
  name: "Setting",
  data() {
    return {
      dialogShow: false,
      nickName: "",
      info: {}
    };
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    beforeClose(action, done) {
      if (action === "confirm") {
        let params = {
          mobile: this.$store.state.mobile,
          nickname: this.nickName,
          loginType: 5
        };
        this.$axios({
          url: "user/nickname",
          method: "post",
          header: {
            contentType: "multipart/form-data;charset=utf8"
          },
          params
        }).then(res => {
          if (res.data.code === 200) {
            Toast({
              message: "修改成功",
              duration: 2000
            });
            this.info.nickname = this.nickName;
            this.nickName = "";
            done();
          } else {
            done();
          }
        });
      } else {
        done();
      }
    },
    getUserInfo() {
      let params = {
        params: {
          mobile: this.$store.state.mobile,
          loginType: 5
          }
      };
      this.$axios.post("user/getUserInfo", params).then(res => {
        if (res.data.code === 200) {
          let data = res.data.data;
          this.info = data;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#setting {
  .header {
    background-color: #02c5ff;
    height: 5rem;
  }
  .info {
    position: relative;
    top: -2rem;
    padding: 0 0.375rem;
    .name-box {
      margin-bottom: 0.25rem;
      text-align: center;
      border-radius: 5px;
      background-color: #fff;
      .info-name {
        position: relative;
        top: -1.5rem;
        .photo {
          display: inline-block;
          width: 3rem;
          height: 3rem;
          background-image: url(../../assets/logo_wbg.png);
          background-size: 100%;
          background-position: center;
          background-repeat: no-repeat;
          border-radius: 50%;
        }
        .name {
          font-size: 0.45rem;
        }
        .address {
          position: relative;
          top: 0.4rem;
          font-size: 0.4rem;
          color: #999;
        }
      }
    }
    .cell-title {
      color: #999;
      .cell-name {
        color: #000;
      }
    }
  }
}
</style>
